/**
 * The talent audit's opening turn, plus labels for its option values.
 *
 * The backend persists nothing for the entry point: after `input: "talent_audit"`
 * the stored history begins at the *answer* to the audit-type question. So on
 * reload both the recruiter's card click and the assistant's "what would you like
 * to evaluate?" turn are missing, and the answer itself replays as a bare value
 * ("role_fit_performance") because the options it came from were never stored.
 *
 * Everything needed to reconstruct that turn faithfully lives here.
 */

/** The assistant's reply to the "Run Talent Audit" card. */
export const AUDIT_TYPE_PROMPT = "Great! Let's get started.\n\nWhat would you like to evaluate?";

export const AUDIT_TYPE_OPTIONS = [
  { text: 'Role Fit & Performance', value: 'role_fit_performance' },
  { text: 'Skills & Capability Audit', value: 'skills_capability_audit' },
  { text: 'Promotion Readiness', value: 'promotion_readiness' },
  { text: 'Leadership Potential', value: 'leadership_potential' },
  { text: 'Team Dynamics & Organizational Effectiveness', value: 'team_dynamics' },
];

/**
 * Human-readable labels for option values that may not be recoverable from the
 * transcript. Used only as a fallback — options carried on a stored assistant
 * turn always win, so the backend stays the source of truth where it provides one.
 */
export const AUDIT_OPTION_LABELS: Record<string, string> = {
  ...Object.fromEntries(AUDIT_TYPE_OPTIONS.map((o) => [o.value, o.text])),
  specific_employee: 'A Specific Employee',
  team_department: 'A Team/Department',
  same_role_cross_department: 'Employees with the same Role across Departments',
  keep_recommendation: 'Keep recommendation',
  behavioral_only: 'Behavioral only',
  technical_only: 'Technical only',
  add_more_context: 'I want to Add more context',
};

export const getAuditOptionLabel = (value: string): string | undefined =>
  AUDIT_OPTION_LABELS[value];
